
import AppTabs from "@/components/layout-editor/Tabs.vue";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: Number
	},
	computed: {
		tabs(): ([number, string])[] {
			return ["pageSettings", "heading", "logos", "text", "columnNames", "freeLines", "freeBlocks"]
				.map((t, i) => [i, this.$ct(t).toString()]);
		}
	},
	components: {
		AppTabs
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
